import PropTypes from 'prop-types';
export const textareaPropTypes = {
  /**
   * Field name value as string
   */
  name: PropTypes.string.isRequired,
  /**
   * Boolean value if field is required
   */
  required: PropTypes.bool,
  /**
   * Additional classname
   */
  classname: PropTypes.string,
  /**
   * Placeholder's value
   */
  placeholder: PropTypes.string
};